import p from 'x/config/platform-specific'

const XDateTimeSinglePicker = p.comp.getXDateTimeSinglePicker()

export default XDateTimeSinglePicker
